import React from "react";
import OurServicesCardDesigns from "./OurServicesCardDesigns";
import BestPrac from './BestPrac';
import CloudAdoptionHero from "./CloudAdoptionHero";
import IndustriesWeServe from "./IndustriesWeServe";
import WhyMoveToCloud from "./WhyMoveToCloud";
import CloudMigrationHighlights from "./CloudMigrationHighlights";
import CloudJourney from "./CloudJourney";
import CloudPotential from "./CloudPotential";
// import ApplicationTopHero from "../../application-development/components/ApplicationTopHero";

function Index() {
    return (
        <div>
            <CloudAdoptionHero />
            <CloudPotential />
            <CloudJourney />
            <BestPrac />
            <CloudMigrationHighlights />
            <WhyMoveToCloud />
            <OurServicesCardDesigns />
            <IndustriesWeServe />
        </div>
    );
}

export default Index;